import { getMeasureUnitHtml } from '@/constants/measureUnits'

// const getTrips = (track) => {}

// eslint-disable-next-line no-nested-ternary
const getCargoName = (cargo) => {
  if (!cargo) return ''
  if (cargo.materialText) return cargo.materialText
  const mat = cargo.material
  return mat?.name || ''
}

const getActiveTrips = track => track.trips?.filter(({ state }) => state === 'active').length
const getCompletedTrips = track => track.trips?.filter(({ state }) => state === 'completed').length
const getTripCargoInfo = tripCargo => `${getCargoName(tripCargo.cargo)} ${tripCargo.volume.toFixed(2)} ${getMeasureUnitHtml(tripCargo.cargo?.unit)}`


export {
  getActiveTrips, getCompletedTrips, getTripCargoInfo, getCargoName,
}
